export const styles = {
  container: {
    backgroundColor: '#f9f9ff',
    height: 'calc(100vh - 72px)',
    padding: '20px 35px 20px 40px',
    fontFamily: 'Proxima Nova, Helvetica, Arial, sans-serif',
  },
  title: {
    fontFamily: 'Proxima Nova, Helvetica, Arial, sans-serif',
    cursor: 'default',
    display: 'flex',
    fontWeight: 800,
  },
  cardWrapper: {
    display: 'flex',
    flexWrap: 'wrap',
    '& > div': {
      marginRight: '8px',
      marginBottom: '8px',
    },
  },
  description: {
    width: '100%',
    maxWidth: '800px',
    color: '#011533',
    fontSize: '16px',
    lineHeight: '22px',
    fontWeight: 400,
    marginBottom: '32px',
  },
  back: {
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    marginRight: '12px',
  },
  button: {
    fontFamily: "'Proxima Nova', sans-serif",
    borderRadius: '12px',
    backgroundColor: 'rgba(238, 67, 96, 1)',
    color: '#FFFFFF',
    textTransform: 'none',
    border: '1px solid rgba(238, 67, 96, 1)',
    minWidth: '200px',
    padding: '7px 20px',
    '&:hover': {
      backgroundColor: 'rgba(238, 67, 96, 1)',
    },
  },
  titleWrap: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  subtitle: {
    color: '#0C172C',
    fontSize: '18px',
    lineHeight: '26px',
    fontWeight: 700,
    margin: '20px 0',
  },
}
